import React from "react";
import { Header } from "../Shoothill.Components/General";
import { Container, Box } from "@material-ui/core";

//EN: use empty generic type to get default react props
export const Layout: React.FC<{}> = props => {
	return (
		<React.Fragment>
			{/* <Header />
			<div style={{ paddingBottom: "75px" }} /> */}
			<Box style={{ backgroundColor: "black" }}>{props.children}</Box>
		</React.Fragment>
	);
};
